import { useQuery } from "@tanstack/react-query";
import { useApi } from "./api";

/**
 * Fetches just the set of item-ids the current user has saved. Used by
 * SaveButton to know its initial state without N per-item queries.
 */
export function useSavedIntelligenceIds() {
  const api = useApi();
  return useQuery({
    queryKey: ["saved-intelligence-ids"],
    queryFn: () => api.get<{ ids: string[] }>("/intelligence/saved-ids"),
    staleTime: 30_000,
    select: (data) => new Set(data.ids),
  });
}
